"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _connectedReactRouter = require("connected-react-router");

var _history = require("history");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _reduxOidc = require("redux-oidc");

var _App = _interopRequireDefault(require("./App"));

var _configureStore = _interopRequireDefault(require("./redux/configureStore"));

var _UserManager = _interopRequireDefault(require("./oidc/UserManager"));

var _Callback = _interopRequireDefault(require("./pages/auth/Callback"));

var _Logout = _interopRequireDefault(require("./pages/auth/Logout"));

var _SilentRenew = _interopRequireDefault(require("./pages/auth/SilentRenew"));

require("./index.less");

require("./index.scss");

var _MobilePageNotFound = _interopRequireDefault(require("./pages/404/MobilePageNotFound"));

const root = document.getElementById('root');
const history = (0, _history.createBrowserHistory)();
const store = (0, _configureStore.default)(history);

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
  store: store
}, /*#__PURE__*/_react.default.createElement(_reduxOidc.OidcProvider, {
  userManager: _UserManager.default,
  store: store
}, /*#__PURE__*/_react.default.createElement(_connectedReactRouter.ConnectedRouter, {
  history: history
}, /*#__PURE__*/_react.default.createElement(_reactRouter.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  exact: true,
  path: "/auth/callback",
  component: _Callback.default
}), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  exact: true,
  path: "/auth/logout",
  component: _Logout.default
}), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  exact: true,
  path: "/auth/renew",
  component: _SilentRenew.default
}), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  path: "/hmpmobile",
  component: _MobilePageNotFound.default
}), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  path: "/",
  component: _App.default
}))))), root);